import { render, staticRenderFns } from "./foodSelectModal.vue?vue&type=template&id=6446a52d&scoped=true&"
import script from "./foodSelectModal.vue?vue&type=script&lang=js&"
export * from "./foodSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446a52d",
  null
  
)

export default component.exports